import { FaRegSun } from "react-icons/fa";
import { MdOutlinePlaylistAdd, MdPlaylistAdd } from "react-icons/md";
import { Outlet } from "react-router-dom";

import { ConfiguracaoDashboard } from "./Dashboard/index";

import { PermissaoUsuariosList } from "./PermissaoUsuarios/List";

import { PermissaoFiliaisCreate } from "./PermissaoFiliais/Create";
import { PermissaoFiliaisEdit } from "./PermissaoFiliais/Edit";
import { PermissaoFiliaisList } from "./PermissaoFiliais/List";
import { AddPermittions } from "./PermissaoUsuarios/Add";
import { ClonePermittion } from "./PermissaoUsuarios/Clone";
import { UsuarioPermissionCreate } from "./Usuario/permissoes/create";
import { EditPermissoes } from "./Usuario/permissoes/edit";
import { ListPermissoes } from "./Usuario/permissoes/ListPermissoes";
import { UsuarioCreate } from "./Usuario/Components/Create";
import { UsuarioEdit } from "./Usuario/Components/Edit";
import UsuarioList from "./Usuario";


const Module = {
  menuItem: {
    to: "/configuracao",
    title: "Configuração",
    icon: FaRegSun,
    id: 1,
    childrens: [
      {
        to: "/configuracao/permissao-de-usuarios",
        title: "Permissão de Usuários",
        icon: MdOutlinePlaylistAdd,
        id: 82,
      },
      {
        to: "/configuracao/permissao-de-filiais",
        title: "Permissão de Filiais",
        icon: MdPlaylistAdd,
        id: 83,
      },
      {
        to: "/configuracao/cadastro-de-usuarios",
        title: "Cadastro de Usuários",
        icon: MdPlaylistAdd,
        id: 81,
      },
    ],
  },

  routes: [
    {
      path: "configuracao",
      element: <ConfiguracaoDashboard />,
    },

    {
      path: "configuracao/permissao-de-usuarios",

      element: <Outlet />,
      children: [
        {
          path: "",
          element: <PermissaoUsuariosList />,
          children: [
            {
              path: ":id/new",
              element: <AddPermittions />,
            },
            {
              path: ":id/clone",
              element: <ClonePermittion />,
            },
          ],
        },
      ],
    },
    {
      path: "configuracao/permissao-de-filiais",
      element: <Outlet />,
      children: [
        { path: "", element: <PermissaoFiliaisList /> },
        { path: ":id", element: <PermissaoFiliaisEdit /> },
        { path: "novo", element: <PermissaoFiliaisCreate /> },
      ],
    },
       {
          path: '/configuracao/cadastro-de-usuarios',
          element: <UsuarioList />,
          children: [
            { path: ':id', element: <UsuarioEdit /> },
            { path: 'novo', element: <UsuarioCreate /> },
            { path: 'listapermissoes/:id', element: <ListPermissoes /> },
            { path: 'listapermissoes/:id/:idpermissao', element: <EditPermissoes /> },
            { path: 'listapermissoes/:id/novo', element: <UsuarioPermissionCreate /> },
          ],
        },
  ],
};

export default Module;
